import axios from "axios";

// Same-origin by default: FastAPI serves both /api/* and this SPA from one origin
// (see Dockerfile). Falling back to "" yields a relative /api, which is correct in
// production and avoids the previous `undefined/api` when the env var was unset.
const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("vd_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export { client as api, API };
